// extracted by mini-css-extract-plugin
module.exports = {"menu":"HeaderNavigationMenu_menu__1LlA9","menuItem":"HeaderNavigationMenu_menuItem__1C9Fp","active":"HeaderNavigationMenu_active__2rnql"};